module.exports = __webpack_public_path__ + "static/media/Pain Management-Medical History-2@3x.8d5aedec.png";